export type CallStatus = "RECORDED" | "IN_PROGRESS" | "WAITING" | "RESOLVED_PENDING_CONFIRMATION";
export type BoardCall = {
  id:string; lineCode:string; lineName:string; productName:string; department:"ELECTRICAL"|"MECHANICAL";
  impact:"STOPPED"|"DEGRADED"|"RUNNING"|"UNKNOWN"; note:string; status:CallStatus; createdAt:string;
  assignedTechnicianName:string|null; waitingReason:string|null; resolutionNote:string|null;
};
export type TeamMember = { id:string; name:string; department:"ELECTRICAL"|"MECHANICAL"; status:"AVAILABLE"|"IN_PROGRESS"; currentLineName:string|null };
export type BoardResponse = { items:BoardCall[]; onDutyTeam:TeamMember[]; generatedAt:string };
export const statusLabel:Record<CallStatus,string> = {
  RECORDED:"Üstlenme bekliyor",
  IN_PROGRESS:"Müdahale sürüyor",
  WAITING:"Beklemede",
  RESOLVED_PENDING_CONFIRMATION:"Operatör onayı bekliyor",
};
export const departmentLabel = (department:BoardCall["department"]) => department === "ELECTRICAL" ? "Elektrik" : "Mekanik";
export const elapsed = (value:string, now:number) => {
  const minutes=Math.max(0,Math.floor((now-new Date(value).getTime())/60_000));
  return minutes<60?`${minutes} dk`:`${Math.floor(minutes/60)} sa ${minutes%60} dk`;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
function nullableText(value: unknown): value is string | null {
  return value === null || typeof value === "string";
}
function isBoardCall(value: unknown): value is BoardCall {
  if (!isRecord(value)) return false;
  return ["id", "lineCode", "lineName", "productName", "note", "createdAt"].every(key => typeof value[key] === "string") &&
    (value.department === "ELECTRICAL" || value.department === "MECHANICAL") &&
    (value.impact === "STOPPED" || value.impact === "DEGRADED" || value.impact === "RUNNING" || value.impact === "UNKNOWN") &&
    (value.status === "RECORDED" || value.status === "IN_PROGRESS" || value.status === "WAITING" || value.status === "RESOLVED_PENDING_CONFIRMATION") &&
    nullableText(value.assignedTechnicianName) && nullableText(value.waitingReason) && nullableText(value.resolutionNote);
}
function isTeamMember(value: unknown): value is TeamMember {
  return isRecord(value) && typeof value.id === "string" && typeof value.name === "string" &&
    (value.department === "ELECTRICAL" || value.department === "MECHANICAL") &&
    (value.status === "AVAILABLE" || value.status === "IN_PROGRESS") && nullableText(value.currentLineName);
}
export function parseTechnicalBoardResponse(value: unknown): BoardResponse {
  if (!isRecord(value) || !Array.isArray(value.items) || !value.items.every(isBoardCall) ||
      !Array.isArray(value.onDutyTeam) || !value.onDutyTeam.every(isTeamMember) || typeof value.generatedAt !== "string")
    throw new Error("Teknik çağrı yanıtı geçersiz.");
  return { items: value.items, onDutyTeam: value.onDutyTeam, generatedAt: value.generatedAt };
}
export function technicalManagerSummary(data: BoardResponse) {
  const items = [...data.items].sort((left, right) => {
    const impact = (left.impact === "STOPPED" ? 0 : 1) - (right.impact === "STOPPED" ? 0 : 1);
    return impact || new Date(left.createdAt).getTime() - new Date(right.createdAt).getTime();
  });
  return {items, unclaimed: items.filter(item => item.status === "RECORDED").length,
    stopped: items.filter(item => item.impact === "STOPPED").length,
    available: data.onDutyTeam.filter(item => item.status === "AVAILABLE").length};
}
